import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useAuthStore } from '@/store/authStore';
import {
  createPayoutAccount,
  fetchBanks,
  fetchPayoutAccounts,
  fetchStoreAccounts,
} from '../apis/bank';

// The lists only change with a database patch
const BANK_STALE_TIME = 60 * 60 * 1000;

export const useBanks = () =>
  useQuery({ queryKey: ['banks'], queryFn: fetchBanks, staleTime: BANK_STALE_TIME });

/** Pembayaran: the store's accounts, in the store's order. */
export const useStoreAccounts = () =>
  useQuery({
    queryKey: ['store-accounts'],
    queryFn: fetchStoreAccounts,
    staleTime: BANK_STALE_TIME,
  });

// Per user, like the other storefront keys
const usePayoutAccountsKey = () => ['payout-accounts', useAuthStore((state) => state.user_id)];

/** Newest first. */
export const usePayoutAccounts = () =>
  useQuery({
    queryKey: usePayoutAccountsKey(),
    queryFn: fetchPayoutAccounts,
    // 403 (not a Family Member) and 404 (no affiliate account) will not change on a retry
    retry: (failureCount, error) =>
      !(isAxiosError(error) && [403, 404].includes(error.response?.status ?? 0)) &&
      failureCount < 3,
  });

export const useCreatePayoutAccount = () => {
  const queryClient = useQueryClient();
  const queryKey = usePayoutAccountsKey();
  return useMutation({
    mutationFn: createPayoutAccount,
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
};
